import React, { useEffect, useState } from 'react'
import { Container, Button, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, IconButton, Stack, TextField } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete';

const CheckInFiles = (props) => {
    const { removeUploadedFile, openAlert, uploadedFiles, setUploadedFiles } = props
    const [fileDescription, setFileDescription] = useState('')
    const [fileUrl, setFileUrl] = useState('')
    const [descriptionRef, setDescriptionRef] = useState(null);
    const [urlRef, setUrlRef] = useState(null);

    const uploadFile = async () => {

        if (!urlRef.value.includes('http://') && !urlRef.value.includes('https://')) {
            openAlert('Wrong URL', 'error')
            setFileUrl('')
            urlRef?.focus()
            return;
        }

        if (!fileDescription.trim()) {
            descriptionRef?.focus();
            return;
        }
        if (!fileUrl.trim()) {
            urlRef?.focus();
            return;
        }

        setUploadedFiles([...uploadedFiles, { id: uploadedFiles.length + 1, description: fileDescription, url: fileUrl, uploaded_at: new Date().toISOString().split('T')[0] }]);
        setFileDescription('');
        setFileUrl('');
    }

    return (
        <Container maxWidth="md" sx={{ marginLeft: '0px' }} >
            <Stack direction='row' spacing={2} sx={{ mt: 2, mb: 2 }}>
                <TextField
                    id="outlined-multiline-static"
                    label="Description"
                    value={fileDescription}
                    sx={{ mt: 2, width: '40%' }}
                    variant='outlined'
                    onChange={(e) => setFileDescription(e.target.value)}
                    inputRef={setDescriptionRef}
                />
                <TextField
                    id="outlined-multiline-static"
                    label="URL"
                    value={fileUrl}
                    fullWidth
                    sx={{ mt: 2, width: '60%' }}
                    variant='outlined'
                    onChange={(e) => setFileUrl(e.target.value)}
                    inputRef={setUrlRef}
                />
                <Button onClick={uploadFile} variant='contained'>Upload</Button>
            </Stack>
            <Divider />
            {uploadedFiles.length > 0 && (
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Description</TableCell>
                                <TableCell>Uploaded At</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>

                            {uploadedFiles?.map((file) => (
                                <TableRow
                                    hover
                                    key={file.description}
                                    sx={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        if (file.url.includes('http://') || file.url.includes('https://')) {
                                            window.open(file.url, '_blank')
                                        } else {
                                            openAlert('Wrong URL', 'error')
                                        }
                                    }}
                                >
                                    <TableCell>{file.description}</TableCell>
                                    <TableCell>{file.uploaded_at}</TableCell>
                                    <TableCell>
                                        <Tooltip title="Delete File">
                                            <IconButton
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    removeUploadedFile(file.id)
                                                }}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </Container>
    )
}

export default CheckInFiles